import { Sport } from 'src/app/models/sports';
import { StoreAction, SportsState } from '../../models/rootState.model';
// tslint:disable: class-name

export const SPORT_ACTIONS = {
  LOAD_SPORTS: '[Sports] -Load sports-',
  LOAD_SPORTS_SUCCESS_FROM_STORAGE: '[Sports] -Sports loaded from storage-',
  LOAD_SPORTS_SUCCESS: '[Sports] -Sports loaded successfuly-',
  LOAD_SPORTS_FAIL: '[Sports] -Load sports failed-',
  LOAD_SPORTS_SKIPPED: '[Sports] -Load Skipped due to cache-',
};

export class Action_Sports_Load implements StoreAction {
  readonly type = SPORT_ACTIONS.LOAD_SPORTS;
  constructor() { }
}

export class Action_Sports_Load_Success_From_Storage implements StoreAction<SportsState> {
  readonly type = SPORT_ACTIONS.LOAD_SPORTS_SUCCESS_FROM_STORAGE;
  constructor(public payload: SportsState) { }
}

export class Action_Sports_Load_Success implements StoreAction {
  readonly type = SPORT_ACTIONS.LOAD_SPORTS_SUCCESS;
  constructor(public payload: Sport[]) { }
}

export class Action_Sports_Load_Fail implements StoreAction<any> {
  readonly type = SPORT_ACTIONS.LOAD_SPORTS_FAIL;
  constructor(public payload: any) { }
}

export class Action_Sports_Load_Skipped implements StoreAction {
  readonly type = SPORT_ACTIONS.LOAD_SPORTS_SKIPPED;
}

export type SportActionType =
  | Action_Sports_Load
  | Action_Sports_Load_Success
  | Action_Sports_Load_Fail
  | Action_Sports_Load_Skipped;
